import { AuthUser } from './authApiHandler';

export const TOKEN = localStorage.getItem('token');

export const getToken = () => localStorage.getItem('token');

export const checkLocalStorage = (key: any) =>
  new Promise((resolve, reject) => {
    try {
      const item = localStorage.getItem(key);

      if (item) {
        resolve(item);
      }
    } catch (error) {
      reject(error);
    }
  });

export const setToken = (token: string) => {
  localStorage.setItem('token', token);
};

export const updateUserDetails = (
  user: AuthUser | null,
  userDetails: { forename: string; surname: string } | null,
) => {
  if (user) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  if (userDetails) {
    localStorage.setItem('userDetails', JSON.stringify(userDetails));
  }
};
